import {
  faBed,
  faMaximize,
  faUsersViewfinder,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useTranslation } from "react-i18next";

function BookingDetails({ data }) {
  const { t } = useTranslation();
  return (
    <div className="px-30 py-30 mt-20 border-light rounded-4">
      <div className="row align-items-center x-gap-15 y-gap-20">
        <div className="text-20 fw-500  mb-20">
          {t("common.yourBookingDetails")}
        </div>
        <div className="col-auto">
          <img
            src={data?.cruisePhoto}
            alt={data?.cruiseName}
            loading="lazy"
            style={{ borderRadius: "10px" }}
            className="size-120   object-cover"
          />
        </div>

        <div className="col">
          <div
            className="d-flex x-gap-5 pb-10"
            dangerouslySetInnerHTML={{
              __html: data?.ratingStarCode,
            }}
          />

          <div className="text-20 lh-17 fw-500 text-main">
            {data?.cruiseName}{" "}
          </div>
          <div className="text-14 lh-15 mt-5">{data?.durationName} </div>
        </div>
      </div>

      <div className="border-top-light mt-30 mb-20"></div>

      <div className="row y-gap-20 justify-between">
        <div className="col-auto">
          <div className="text-15">{t("common.checkIn")}</div>
          <div className="fw-500">{data?.checkInDate}</div>
          {/* <div className="text-15 text-light-1">
                            15:00 – 23:00{" "}
                          </div> */}
        </div>

        <div className="col-auto md:d-none">
          <div className="h-full w-1 bg-border"></div>
        </div>

        <div className="col-auto text-right md:text-left">
          <div className="text-15">{t("common.checkOut")}</div>
          <div className="fw-500">{data?.checkOutDate}</div>
          {/* <div className="text-15 text-light-1">
                            01:00 – 11:00{" "}
                          </div> */}
        </div>
      </div>
      <div className="border-top-light mt-30 mb-20"></div>

      <div className="text-15 mb-10">{t("common.youSelected")}</div>
      {data?.cabinsChoices?.map((cabin, index) => (
        <div
          className="row y-gap-20 justify-between items-center"
          key={cabin.cabinID}
        >
          <div className="col-auto d-flex">
            <img
              style={{ borderRadius: "5px" }}
              src={cabin.cabinPhoto}
              alt=""
              className="me-2"
              width="50"
            />{" "}
            <div className="text-main fw-500 text-16 mb-10 mb-lg-0">
              {cabin.cabinNameSYS}
              <br />
              <span className="text-12 text-secondary ">
                {" "}
                ({cabin.rateTypeName})
              </span>
            </div>
          </div>
          <div className="col-auto d-flex flex-row flex-lg-column align-items-end justify-between w-100 w-lg-auto justify-content-lg-start">
            <div className="col-auto d-flex align-items-center">
              <div className="text-12 text-secondary">
                ({cabin.cabinBedType}){" "}
              </div>

              <FontAwesomeIcon
                icon={faBed}
                className="text-12 text-main ps-1"
              />
            </div>
            <div className="col-auto  d-flex align-items-center">
              <div className="text-12 text-secondary">
                {/* Max Occupancy */}(
                {`${cabin.adultsNum} ${
                  cabin.adultsNum > 1
                    ? t("common.adults")
                    : t("common.adults").slice(0, -1)
                }`}
                {`${
                  cabin.childrenNum > 0
                    ? ` & ${cabin.childrenNum} ${
                        cabin.childrenNum > 1
                          ? t("common.children")
                          : t("common.children").slice(0, -1)
                      }`
                    : ""
                }`}
                )
              </div>
              <FontAwesomeIcon
                icon={faUsersViewfinder}
                className="text-12 text-main ps-1"
              />
            </div>
            <div className="col-auto  d-flex align-items-center">
              <div className="text-12 text-secondary">
                ({cabin.cabinSize}){/* {cabin.sizeMeasurement}{" "} */}
              </div>
              <FontAwesomeIcon
                icon={faMaximize}
                className="text-12 text-main ps-1"
              />
            </div>
          </div>{" "}
          {index < data?.cabinsChoices.length - 1 && (
            <div className="border-top-light my-1"></div>
          )}
        </div>
      ))}
    </div>
  );
}

export default BookingDetails;
